export function getAddressString(addressDTO) {
    if (!addressDTO)
        return '';
        
    let address = typeof(addressDTO.Address) !== 'undefined' ?
        isNullOrWhitespace(addressDTO.Address) ? '' : `${addressDTO.Address}` : '';
    address += typeof(addressDTO.Flat) !== 'undefined' ?
        isNullOrWhitespace(addressDTO.Flat) ? '' : `, кв. ${addressDTO.Flat}` : '';
    address += typeof(addressDTO.Entrance) !== 'undefined' ?
        isNullOrWhitespace(addressDTO.Entrance) ? '' : `, подъезд ${addressDTO.Entrance}` : '';
    address += typeof(addressDTO.Floor) !== 'undefined' ?
        isNullOrWhitespace(addressDTO.Floor) ? '' : `, этаж ${addressDTO.Floor}` : '';
    address += typeof(addressDTO.IntercomCode) !== 'undefined' ?
        isNullOrWhitespace(addressDTO.IntercomCode) ? '' : `, код домофона ${addressDTO.IntercomCode}` : '';
    return address;
}

function isNullOrWhitespace(val) {
    if (val == null) return true;

    return val.replace(/\s/g, '').length < 1;
}


// WEBPACK FOOTER //
// ./src/extensions/addressHelper.js